<template>
<div>
	<div class="background" ref='back_first'
		v-show="activeBackground"
	/>
	<div class="background" ref="back_second"
		v-show="!activeBackground"
	/>
</div>
</template>

<script>
import { randomNumber } from '@/utils/helpers'

export default {
	props: {
		type: {
			type: String
		},
		interval: {
			type: Number
		},
		clickEvent: {
			type: String
		}
	},
	data: () => ({
		changeBackgroundInterval: null,
		activeBackground: true
	}),
	methods: {
		setRandomBack(newElement, oldElement) {
			let imageUrl = require('../../assets/images/backList/back_' + this.getImageNotEqualOld(oldElement) + '.jpg')
			newElement.style.backgroundImage = "url(" + imageUrl + ")"
			
		},
		getImageNotEqualOld(element) {
			if(element.style.backgroundImage == '') {
				return randomNumber(1, 4)
			}
			let currentIndex = element.style.backgroundImage.split('back_')[1].charAt(0)
			let randomIndex = randomNumber(1, 4)
			while(randomIndex == currentIndex) {
				randomIndex = randomNumber(1, 4)
			}
			return randomIndex
		},
		changeBack() {
			this.activeBackground = !this.activeBackground
			if(this.activeBackground) {
				this.setRandomBack(this.$refs.back_second, this.$refs.back_first)
			} else {
				this.setRandomBack(this.$refs.back_first, this.$refs.back_second)
			}
		}
	},
	mounted() {
		this.setRandomBack(this.$refs.back_second, this.$refs.back_first)
		this.setRandomBack(this.$refs.back_first, this.$refs.back_second)

		if(this.type == 'interval') {
			this.changeBackgroundInterval = setInterval(function() {
				this.changeBack()
			}.bind(this), this.interval)
		}
		if(this.type == 'click') {
			this.$root.$on(this.clickEvent, () => {
				this.changeBack()
			})
		}
	},
	beforeDestroy() {
		clearInterval(this.changeBackgroundInterval)
	}
}
</script>

<style>
</style>
